import { useState } from 'react';
import {
  TextField,
  Button,
  Stack,
  Box,
  useTheme,
  useMediaQuery,
} from '@mui/material';

const ProbabilityForm = ({ onAdd, tiers = [] }) => {
  const [tier, setTier] = useState('');
  const [probability, setProbability] = useState('');
  const [color, setColor] = useState('#95a5a6');

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleAdd = () => {
    if (!tier || probability === '') {
      alert('등급과 확률을 모두 입력해주세요.');
      return;
    }

    const exists = tiers.some(
      (t) => t.tier.toLowerCase() === tier.toLowerCase()
    );
    if (exists) {
      alert(`"${tier}" 등급은 이미 등록되어 있습니다.`);
      return;
    }

    onAdd({
      tier,
      probability: parseFloat(probability),
      color: color || '#95a5a6',
    });

    setTier('');
    setProbability('');
    setColor('#95a5a6');
  };

  if (isMobile) {
    // 📱 모바일 2줄 구조
    return (
      <Stack spacing={2}>
        <Stack direction="row" spacing={2}>
          <TextField
            label="등급 이름"
            value={tier}
            onChange={(e) => setTier(e.target.value)}
            size="small"
            fullWidth
          />
          <TextField
            label="확률 (%)"
            type="number"
            value={probability}
            onChange={(e) => setProbability(e.target.value)}
            inputProps={{ step: 0.01, min: 0 }}
            size="small"
            fullWidth
          />
        </Stack>

        <Stack direction="row" spacing={2} alignItems="center">
          <Box display="flex" alignItems="center" gap={1}>
            <input
              type="color"
              value={color}
              onChange={(e) => setColor(e.target.value)}
              style={{
                width: 40,
                height: 40,
                border: 'none',
                padding: 0,
                background: 'none',
                cursor: 'pointer',
              }}
            />
            <TextField
              label="HEX"
              value={color}
              onChange={(e) => setColor(e.target.value)}
              sx={{ width: 100 }}
              size="small"
            />
          </Box>
          <Button variant="outlined" size="small" onClick={handleAdd}>
            등급 추가
          </Button>
        </Stack>
      </Stack>
    );
  }

  // 💻 PC: 기존 가로 정렬 유지
  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <TextField
        label="등급 이름"
        value={tier}
        onChange={(e) => setTier(e.target.value)}
      />
      <TextField
        label="확률 (%)"
        type="number"
        value={probability}
        onChange={(e) => setProbability(e.target.value)}
        inputProps={{ step: 0.01, min: 0 }}
      />
      <Box display="flex" alignItems="center" gap={1}>
        <input
          type="color"
          value={color}
          onChange={(e) => setColor(e.target.value)}
          style={{
            width: 40,
            height: 40,
            border: 'none',
            padding: 0,
            background: 'none',
            cursor: 'pointer',
          }}
        />
        <TextField
          label="HEX"
          value={color}
          onChange={(e) => setColor(e.target.value)}
          sx={{ width: 100 }}
        />
      </Box>
      <Button variant="outlined" onClick={handleAdd}>
        등급 추가
      </Button>
    </Stack>
  );
};

export default ProbabilityForm;
